
const games = [
    {
  id: 1,
  slug: "detective-x",
  title: "Detective X and the Missing Variable",
  

  thumbnail:
    "/thumbnails/detectiveX.png",

  description:
    "Menjadi detektif yang bertugas mengisolasi dan mencari nilai variabel X yang hilang dari suatu persamaan.",

  category: "Matematika",

  gradeLevel: "Grades 4-6+",

  platform: "Web",

  url: "https://www.abcya.com/games/detective-x-algebra",

  // PEDAGOGICAL
  topic:
    "Aljabar Dasar, Variabel, & Berpikir Aljabar (Mental Math)",

  curriculum:
    "Fase B - Kurikulum Merdeka",

  cognitiveSkill:
    "Mental Math, Problem Solving",

  // GAMEPLAY
  genre:
    "Puzzle Logika / Detektif",

  duration:
    "5–10 Menit",

  access:
    "Web (Tanpa Login)",

  // EGQI
  pq: 4.75,
  cq: 5.00,
  gq: 4.25,
  eq: 4.00,
  prq: 4.75,

  expertScore: 4.55,

  // STRENGTH
  bestScore:
    "Content Quality",

  bestScoreValue:
    5.00,

  secondBest:
    "Pedagogical Quality",

  secondBestValue:
    4.75,

  // PERSONA
  persona:
    "Kurikulum-Sentris / Fokus Akademik",

  scenario:
    "Cocok untuk asesmen formatif atau latihan mandiri pasca materi aljabar.",

  teacherScore: 0,
  totalReviews: 0,
},

  {
  id: 2,
  slug: "dirt-bike-proportions",
  title: "Dirt Bike Proportions",

  thumbnail:
    "/thumbnails/dirtbike.png",

  description:
    "Balapan motor trail dimana kecepatan motor ditentukan oleh ketepatan memilih pecahan senilai dan rasio yang benar.",

  category: "Matematika",

  gradeLevel: "Grades 4-6+",

  platform: "Web",

  url:
    "https://www.abcya.com/games/fractions_equal_proportions",

  // PEDAGOGICAL
  topic:
    "Rasio, Proporsi, & Kecepatan Berhitung (Fluency)",

  curriculum:
    "Fase B - Kurikulum Merdeka",

  cognitiveSkill:
    "Fluency, Problem Solving",

  // GAMEPLAY
  genre:
    "Multiplayer Racing",

  duration:
    "3–5 Menit",

  access:
    "Web (Kompetitif)",

  // EGQI
  pq: 4.00,
  cq: 4.75,
  gq: 4.25,
  eq: 5.00,
  prq: 4.50,

  expertScore: 4.50,

  // STRENGTH
  bestScore:
    "Engagement Quality",

  bestScoreValue:
    5.00,

  secondBest:
    "Content Quality",

  secondBestValue:
    4.75,

  // PERSONA
  persona:
    "Fasilitator / Pembelajaran Aktif",

  scenario:
    "Ideal untuk ice breaking di tengah kelas atau turnamen matematika kelompok.",

  teacherScore: 0,
  totalReviews: 0,
  },

 {
  id: 3,
  slug: "2048",
  title: "2048",

  thumbnail:
    "/thumbnails/2048.png",

  description:
    "Menggeser dan menggabungkan kotak dengan angka yang sama untuk mencapai angka 2048 menggunakan kelipatan dua.",

  category: "Matematika",

  gradeLevel: "Grades 4-6+",

  platform: "Web / Mobile",

  url:
    "https://www.abcya.com/games/2048",

  // PEDAGOGICAL
  topic:
    "Kelipatan, Perpangkatan Dua, & Logika Spasial",

  curriculum:
    "Fase B - Kurikulum Merdeka",

  cognitiveSkill:
    "Logika Spasial, Problem Solving",

  // GAMEPLAY
  genre:
    "Grid Slide Puzzle",

  duration:
    "5–15 Menit",

  access:
    "Web / Mobile",

  // EGQI
  pq: 3.50,
  cq: 4.00,
  gq: 4.25,
  eq: 4.50,
  prq: 4.75,

  expertScore: 4.20,

  // STRENGTH
  bestScore:
    "Practicality Quality",

  bestScoreValue:
    4.75,

  secondBest:
    "Engagement Quality",

  secondBestValue:
    4.50,

  // PERSONA
  persona:
    "Mandiri / Eksploratif",

  scenario:
    "Sangat pas untuk aktivitas pengayaan mandiri bagi siswa cepat (fast learners).",

  teacherScore: 0,
  totalReviews: 0,
},
  {
  id: 4,
  slug: "brainie",
  title: "Brainie",

  thumbnail:
    "/thumbnails/brainie.png",

  description:
    "Permainan berhitung cepat yang menantang siswa menyelesaikan operasi matematika dalam waktu terbatas.",

  category: "Matematika",

  gradeLevel: "Grades 3-6",

  platform: "Web",

  url:
    "https://www.abcya.com/games/brainie_math_game",

  topic:
    "Aritmetika Dasar & Mental Math",

  curriculum:
    "Fase B",

  cognitiveSkill:
    "Mental Math, Fluency",

  genre:
    "Drop Puzzle",

  duration:
    "3–5 Menit",

  access:
    "Web (Tanpa Login)",

  pq: 3.75,
  cq: 4.50,
  gq: 4.50,
  eq: 4.00,
  prq: 4.75,

  expertScore: 4.30,

  bestScore:
    "Content Quality",

  bestScoreValue:
    4.50,

  secondBest:
    "Game Quality",

  secondBestValue:
    4.50,

  persona:
    "Penguatan Keterampilan",

  scenario:
    "Digunakan untuk latihan cepat sebelum atau sesudah pembelajaran inti.",

  teacherScore: 0,
  totalReviews: 0,
},

{
  id: 5,
  slug: "clear-it-multiplication",
  title: "Clear It Multiplication",

  thumbnail:
    "/thumbnails/clearitmul.png",

  description:
    "Puzzle bubble shooter yang mengharuskan siswa menyelesaikan soal perkalian untuk menghilangkan gelembung.",

  category: "Matematika",

  gradeLevel: "Grades 3-5",

  platform: "Web",

  url:
    "https://www.abcya.com/games/clear_it_multiplication",

  topic:
    "Perkalian & Fakta Dasar Matematika",

  curriculum:
    "Fase B",

  cognitiveSkill:
    "Fluency, Recall",

  genre:
    "Bubble Shooter",

  duration:
    "5–8 Menit",

  access:
    "Web (Tanpa Login)",

  pq: 4.50,
  cq: 5.00,
  gq: 4.50,
  eq: 4.00,
  prq: 5.00,

  expertScore: 4.60,

  bestScore:
    "Content Quality",

  bestScoreValue:
    5.00,

  secondBest:
    "Practicality Quality",

  secondBestValue:
    5.00,

  persona:
    "Guru SD Kelas Rendah",

  scenario:
    "Digunakan sebagai latihan penguatan tabel perkalian setelah pembelajaran konsep.",

  teacherScore: 0,
  totalReviews: 0,
},

{
  id: 6,
slug: "Clear It Addition",
  title: "Clear It Addition",

  thumbnail:
    "/thumbnails/clearitadd.png",

  description:
    "Permainan puzzle yang melatih kemampuan penjumlahan melalui mekanisme bubble shooter interaktif.",

  category: "Matematika",

  gradeLevel: "Grades 2-5",

  platform: "Web",

  url:
    "https://www.abcya.com/games/clear_it_addition",

  topic:
    "Penjumlahan Dasar",

  curriculum:
    "Fase A - B",

  cognitiveSkill:
    "Numerasi Dasar, Fluency",

  genre:
    "Bubble Shooter",

  duration:
    "5–8 Menit",

  access:
    "Web (Tanpa Login)",

  pq: 3.75,
  cq: 4.00,
  gq: 4.00,
  eq: 4.00,
  prq: 5.00,

  expertScore: 4.15,

  bestScore:
    "Practicality Quality",

  bestScoreValue:
    5.00,

  secondBest:
    "Content Quality",

  secondBestValue:
    4.00,

  persona:
    "Guru SD Awal",

  scenario:
    "Digunakan untuk memperkuat kemampuan berhitung dasar pada siswa sekolah dasar.",

  teacherScore: 0,
  totalReviews: 0,
},

{
  id: 7,
slug: "break-the-bank-counting",
  title: "Break the Bank - Counting",

  thumbnail:
    "/thumbnails/breakthebank.png",

  description:
    "Simulasi menghitung uang dan kembalian menggunakan berbagai denominasi koin dan uang kertas.",

  category: "Matematika",

  gradeLevel: "Grades 3-5",

  platform: "Web",

  url:
    "https://www.abcya.com/games/break_the_bank_counting",

  topic:
    "Nilai Uang & Operasi Hitung Sederhana",

  curriculum:
    "Fase B",

  cognitiveSkill:
    "Numerasi Kontekstual, Problem Solving",

  genre:
    "Simulation",

  duration:
    "5 Menit",

  access:
    "Web (Tanpa Login)",

  pq: 4.25,
  cq: 4.25,
  gq: 4.25,
  eq: 4.00,
  prq: 5.00,

  expertScore: 4.35,

  bestScore:
    "Practicality Quality",

  bestScoreValue:
    5.00,

  secondBest:
    "Pedagogical Quality",

  secondBestValue:
    4.25,

  persona:
    "Kontekstual / Kehidupan Nyata",

  scenario:
    "Cocok digunakan saat pembelajaran nilai uang dan transaksi sederhana.",

  teacherScore: 0,
  totalReviews: 0,
},

{
  id: 8,
  slug: "comparing-number-values",
  title: "Comparing Number Values",

  thumbnail:
    "/thumbnails/comparing.png",

  description:
    "Melatih kemampuan membandingkan bilangan menggunakan simbol lebih besar, lebih kecil, dan sama dengan.",

  category: "Matematika",

  gradeLevel: "Grades 1-5",

  platform: "Web",

  url:
    "https://www.abcya.com/games/comparing_number_values",

  topic:
    "Perbandingan Bilangan",

  curriculum:
    "Fase A - B",

  cognitiveSkill:
    "Number Sense, Numerasi Dasar",

  genre:
    "MCQ Quiz",

  duration:
    "3–5 Menit",

  access:
    "Web (Tanpa Login)",

  pq: 4.25,
  cq: 5.00,
  gq: 4.25,
  eq: 4.00,
  prq: 5.00,

  expertScore: 4.50,

  bestScore:
    "Content Quality",

  bestScoreValue:
    5.00,

  secondBest:
    "Practicality Quality",

  secondBestValue:
    5.00,

  persona:
    "Guru SD Kelas Awal",

  scenario:
    "Ideal untuk memperkenalkan konsep lebih besar, lebih kecil, dan sama dengan.",

  teacherScore: 0,
  totalReviews: 0,
},

{
  id: 9,
  slug: "adventure-man-dungeon-dash",
  title: "Adventure Man Dungeon Dash",

  thumbnail:
    "/thumbnails/mandange.png",

  description:
    "Petualangan platformer yang mengajak siswa menyelesaikan tantangan pola dan urutan angka untuk melanjutkan perjalanan.",

  category: "Matematika",

  gradeLevel: "Grades 1-5",

  platform: "Web",

  url:
    "https://www.abcya.com/games/adventure_man_dash_numbers",

  topic:
    "Pola Bilangan & Number Sequence",

  curriculum:
    "Fase A - B",

  cognitiveSkill:
    "Pattern Recognition, Problem Solving",

  genre:
    "Platformer Adventure",

  duration:
    "5 Menit",

  access:
    "Web (Tanpa Login)",

  pq: 4.50,
  cq: 4.75,
  gq: 4.25,
  eq: 5.00,
  prq: 5.00,

  expertScore: 4.70,

  bestScore:
    "Engagement Quality",

  bestScoreValue:
    5.00,

  secondBest:
    "Practicality Quality",

  secondBestValue:
    5.00,

  persona:
    "Gamifikasi Tinggi",

  scenario:
    "Sangat cocok untuk meningkatkan motivasi siswa yang cepat bosan dengan latihan konvensional.",

  teacherScore: 0,
  totalReviews: 0,
},

{
  id: 10,
  slug: "base-ten-fun",
  title: "Base Ten Fun",

  thumbnail:
    "/thumbnails/baseten.png",

  description:
    "Menggunakan blok digital untuk membantu siswa memahami nilai tempat, puluhan, ratusan, dan ribuan secara visual.",

  category: "Matematika",

  gradeLevel: "Grades K-4",

  platform: "Web",

  url:
    "https://www.abcya.com/games/base_ten_fun",

  topic:
    "Nilai Tempat (Place Value)",

  curriculum:
    "Fase A",

  cognitiveSkill:
    "Number Sense, Visual Reasoning",

  genre:
    "Virtual Manipulative",

  duration:
    "5–10 Menit",

  access:
    "Web (Tanpa Login)",

  pq: 4.00,
  cq: 4.00,
  gq: 4.00,
  eq: 3.75,
  prq: 5.00,

  expertScore: 4.15,

  bestScore:
    "Practicality Quality",

  bestScoreValue:
    5.00,

  secondBest:
    "Pedagogical Quality",

  secondBestValue:
    4.00,

  persona:
    "Visual Learner",

  scenario:
    "Digunakan saat guru memperkenalkan konsep nilai tempat menggunakan representasi visual.",

  teacherScore: 0,
  totalReviews: 0,
},

{
  id: 11,
  slug: "adventure-man-counting-quest",
  title: "Adventure Man Counting Quest",

  thumbnail:
    "/thumbnails/mancount.png",

  description:
    "Petualangan edukatif yang melatih kemampuan menghitung berurutan dan skip counting melalui tantangan interaktif.",

  category: "Matematika",

  gradeLevel: "Grades K-6",

  platform: "Web",

  url:
    "https://www.abcya.com/games/adventure-man-counting",

  topic:
    "Counting & Skip Counting",

  curriculum:
    "Fase A - B",

  cognitiveSkill:
    "Counting Fluency, Pattern Recognition",

  genre:
    "Maze Runner Adventure",

  duration:
    "5 Menit",

  access:
    "Web (Tanpa Login)",

  pq: 3.75,
  cq: 4.00,
  gq: 3.75,
  eq: 4.00,
  prq: 5.00,

  expertScore: 4.10,

  bestScore:
    "Practicality Quality",

  bestScoreValue:
    5.00,

  secondBest:
    "Content Quality",

  secondBestValue:
    4.00,

  persona:
    "Gamified Learning",

  scenario:
    "Sangat cocok untuk siswa sekolah dasar yang sedang belajar skip counting dan urutan angka.",

  teacherScore: 0,
  totalReviews: 0,
},

{
  id: 12,
  slug: "100-snowballs",
  title: "100 Snowballs!",

  thumbnail:
    "/thumbnails/snow.png",

  description:
    "Permainan kreatif yang membantu siswa memahami kuantitas dan pengelompokan angka melalui aktivitas melempar bola salju.",

  category: "Matematika",

  gradeLevel: "PRE-K - 5",

  platform: "Web",

  url:
    "https://www.abcya.com/games/one_hundred_snowballs",

  topic:
    "Kuantitas & Pengelompokan Bilangan",

  curriculum:
    "PAUD - Fase A",

  cognitiveSkill:
    "Number Sense, Counting",

  genre:
    "Sandbox Interactive",

  duration:
    "5–10 Menit",

  access:
    "Web (Tanpa Login)",

  pq: 1.75,
  cq: 3.00,
  gq: 2.75,
  eq: 3.25,
  prq: 4.75,

  expertScore: 3.10,

  bestScore:
    "Practicality Quality",

  bestScoreValue:
    4.75,

  secondBest:
    "Engagement Quality",

  secondBestValue:
    3.25,

  persona:
    "Eksploratif Awal",

  scenario:
    "Cocok untuk pengenalan konsep jumlah dan kelompok bilangan pada siswa usia dini.",

  teacherScore: 0,
  totalReviews: 0,
},
];

export default games;